import AbstractCollision from './abstractCollision';

/**
 * In poly collision. All points of the item are inside of the area spanned by the other item.
 *
 * @class InPolyCollision
 * @extends AbstractCollision
 */
export default class InPolyCollision extends AbstractCollision {}
